/* Kings Fury — reveal elements when they scroll into view.
   Loaded with `defer`, so the DOM is ready when this runs.

   Every [data-kf-reveal] element is observed individually and gets the
   `kf-in-view` class when it enters the viewport. Elements inside a shared
   [data-kf-reveal-group] receive an incrementing --kf-stagger index so
   siblings (cards, list rows, etc.) reveal in sequence instead of at once. */
(function () {
  var els = [].slice.call(document.querySelectorAll('[data-kf-reveal]'));
  if (!els.length) return;

  // Assign stagger indexes within each reveal group.
  [].forEach.call(document.querySelectorAll('[data-kf-reveal-group]'), function (group) {
    [].forEach.call(group.querySelectorAll('[data-kf-reveal]'), function (item, i) {
      item.style.setProperty('--kf-stagger', i);
    });
  });

  // No IntersectionObserver support -> just show everything.
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) {
      el.classList.add('kf-in-view');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('kf-in-view');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  els.forEach(function (el) {
    observer.observe(el);
  });
})();
